module.exports = __webpack_public_path__ + "img/198-2f2b14.png";